function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "camera",
  transform: "translate(-13)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M3.812,26.748A3.841,3.841,0,0,1,1.13,25.617,3.654,3.654,0,0,1,0,22.936V6.848A3.844,3.844,0,0,1,1.13,4.167a3.657,3.657,0,0,1,2.681-1.13H9.142V2.972a2.978,2.978,0,0,1,3-2.972h9.691a2.956,2.956,0,0,1,2.1.872,2.9,2.9,0,0,1,.872,2.1v.065h5.362a3.657,3.657,0,0,1,2.682,1.13,3.657,3.657,0,0,1,1.13,2.681V22.936a3.841,3.841,0,0,1-1.13,2.681,3.654,3.654,0,0,1-2.682,1.131Z",
  transform: "translate(0 0.065)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-2",
  "data-name": "Shape",
  d: "M2.326,13.568a7.954,7.954,0,1,1,5.621,2.326A7.96,7.96,0,0,1,2.326,13.568Z",
  transform: "translate(9.045 7.01)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 1.583,
  cy: 1.583,
  r: 1.583,
  transform: "translate(26.909 6.978)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.4
}));

function SvgDesktopI1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.384,
    height: 27.148,
    viewBox: "0 0 34.384 27.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(13.2 0.135)",
    style: {
      isolation: "isolate"
    }
  }, _ref2));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopI1);
export default __webpack_public_path__ + "static/media/desktopI1.21dbcbd6.svg";
export { ForwardRef as ReactComponent };